import { useEffect, useState } from 'react';
import { 
  ResponsiveContainer, 
  LineChart, 
  Line, 
  CartesianGrid, 
  XAxis, 
  YAxis, 
  Tooltip, 
  Legend,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  ReferenceLine
} from 'recharts';

// export const BarChart = (props) => {
//   const { className, width, height } = props;
//   const margin = { top: 20, right: 20, bottom: 20, left: 200 };
//   const data = [{country: 'USA', population: 300}, {country: 'UK', population: 200}, {country: 'Canada', population: 100}];
  
//   // useEffect(() => {
//   //   const row = d => {
//   //     return d;
//   //   }
//   // }, [])
//   const innerHeight = height - margin.top - margin.bottom;
//   const innerWidth = width - margin.left - margin.right;

//   const yScale = d3.scaleBand()
//     .domain(data.map(d => d.country)) // the options for the scale
//     .range([0, innerHeight]); // the pixel range of the scale 

//   const xScale = d3.scaleLinear()
//     .domain([0, d3.max(data, d => d.population)]) 
//     .range([0, innerWidth]); 

//   console.log(yScale.domain());
//   console.log(yScale('Canada'));
//   console.log(yScale.bandwidth())
//   return (
//     <div className={`bar-chart${className ? ` ${className}` : ''}`}>
//       <svg width={width} height={height}>
//         <g transform={`translate(${margin.left}, ${margin.top})`}>
//           {xScale.ticks(7).map(tickValue => (
//             <g key={tickValue} transform={`translate(${xScale(tickValue)},0)`}>
//               <line y2={innerHeight} stroke="rgb(205, 205, 205)"/>
//               <text style={{textAnchor: 'middle'}} y={innerHeight + 8} dy=".71em">
//                 {tickValue}
//               </text>
//             </g>
//           ))}
//           {yScale.domain().map(tickValue => (
//               <text key={tickValue} dy=".32em" style={{textAnchor: 'end'}} x="-3" y={yScale(tickValue) + yScale.bandwidth() / 2}>
//                 {tickValue}
//               </text>
//           ))}
//           {data.map(d => 
//             <rect 
//               key={d.country}
//               x={0} 
//               y={yScale(d.country)} // finds the y position of the country based on the range
//               width={xScale(d.population)} 
//               height={yScale.bandwidth()} 
//             />
//           )}
//         </g>
//       </svg>
//     </div>
//   )
// }

export const LineGraph = (props) => {
  const {
    width, 
    height, 
    data, 
    heading, 
    className, 
    keys, 
    formatter, 
    tickFormatter, 
    labelFormatter,
    keyLabels,
    yLeftTickFormatter,
    yRightTickFormatter,
    style,
    // [{ x, label?, color? }] — `x` must equal a `Date` value in `data`.
    markers,
    showLegend = true,
    // Optional prior-period series keys (dashed, muted), same y-axes as `keys`.
    comparisonKeys
  } = props;
  const determineInterval = (dataLength) => {
    if (dataLength <= 10) return 0; // Show all labels if data points are 10 or fewer
    if (dataLength <= 20) return 1; // Show every other label if data points are 20 or fewer
    return Math.floor(dataLength / 10); // Otherwise, show one label every few points
  };
  const interval = determineInterval(data.length);
  const fillParent = height === '100%';
  const hasLeft = Boolean(keys?.[0]);
  const hasRight = Boolean(keys?.[1]);
  const cmpLeft = hasLeft ? comparisonKeys?.[0] : null;
  const cmpRight = hasRight ? comparisonKeys?.[1] : null;
  const chart = (
    <LineChart data={data} className="line-graph__graph">
      <CartesianGrid vertical={false} strokeDasharray="0" stroke="#cdcdcd" />
      <XAxis 
        dataKey="Date" 
        tickFormatter={value => {
        if (tickFormatter) return tickFormatter(value);
        else return value;
        }} 
        interval={interval}
        angle={-45}
        textAnchor="end"
      />
      {(hasLeft || !hasRight) && (
        <YAxis yAxisId="left" tickFormatter={hasLeft ? yLeftTickFormatter : undefined} />
      )}
      {hasLeft && (
        <Line
          yAxisId="left"
          type="monotone"
          dataKey={keys[0]}
          name={keyLabels?.[keys[0]] || keys[0]}
          stroke="#F8A305"
          dot={false}
          activeDot={{ r: 3.75, fill: '#F8A305', stroke: '#F8A305' }}
        />
      )}
      {cmpLeft && (
        <Line
          yAxisId="left"
          type="monotone"
          dataKey={cmpLeft}
          name={keyLabels?.[cmpLeft] || cmpLeft}
          stroke="#F8A305"
          strokeOpacity={0.45}
          strokeDasharray="6 4"
          dot={false}
          activeDot={{ r: 3, fill: '#F8A305', stroke: '#F8A305', fillOpacity: 0.55 }}
        />
      )}
      {hasRight && (
        <>
        <Line
          yAxisId="right"
          type="monotone"
          dataKey={keys[1]}
          name={keyLabels?.[keys[1]] || keys[1]}
          stroke="#F51504"
          dot={false}
          activeDot={{ r: 3.75, fill: '#F51504', stroke: '#F51504' }}
        />
        {cmpRight && (
          <Line
            yAxisId="right"
            type="monotone"
            dataKey={cmpRight}
            name={keyLabels?.[cmpRight] || cmpRight}
            stroke="#F51504"
            strokeOpacity={0.45}
            strokeDasharray="6 4"
            dot={false}
            activeDot={{ r: 3, fill: '#F51504', stroke: '#F51504', fillOpacity: 0.55 }}
          />
        )}
        <YAxis yAxisId="right" orientation="right" tickFormatter={yRightTickFormatter} />
        </>
      )}
      {(markers || []).map((m, i) => (
        <ReferenceLine
          key={`${m.x}-${i}`}
          yAxisId="left"
          x={m.x}
          stroke={m.color || '#8a8a8a'}
          strokeDasharray="3 3"
          ifOverflow="extendDomain"
          label={m.label ? { value: m.label, position: 'top', fontSize: 10, fill: m.color || '#8a8a8a' } : undefined}
        />
      ))}
      <Tooltip 
        formatter={(value, name, props) => {
          if (!formatter) return value;
          if (typeof formatter === 'function') return formatter(value, name, props);
          if (formatter?.format) return formatter.format(value);
          return value;
        }}
        labelFormatter={(value) => {
          if (labelFormatter) return labelFormatter(value);
          const newDate = new Date(value);
          return `${newDate.getMonth()+1}/${newDate.getDate()}/${newDate.getFullYear()}`
        }}
      />
      {showLegend && <Legend wrapperStyle={{ paddingTop: 30 }} />}
    </LineChart>
  );
  return (
    <div
      className={`line-graph${className ? ` ${className}` : ''}`}
      style={{
        ...(fillParent
          ? { display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }
          : {}),
        ...(style || {})
      }}
    >
      {heading && <div className="line-graph__heading">{heading}</div>}
      {fillParent ? (
        <div style={{ flex: 1, minHeight: 0, width: '100%' }}>
          <ResponsiveContainer width="100%" height="100%">
            {chart}
          </ResponsiveContainer>
        </div>
      ) : (
        <ResponsiveContainer width={width} height={height}>
          {chart}
        </ResponsiveContainer>
      )}
    </div>
  )
}

export const Scorecard = (props) => {
  // invertChange: up is bad / down is good (e.g. CPA, CPC).
  const { data, className, title, tooltip, change, invertChange = false } = props;
  const hasChange = change !== undefined;
  let changeNode = null;
  if (hasChange) {
    if (change == null || !Number.isFinite(Number(change))) {
      changeNode = <div className="scorecard__change scorecard__change--empty">—</div>;
    } else {
      const pct = Number(change) * 100;
      const rounded = Math.round(pct * 10) / 10;
      const abs = Math.abs(rounded);
      const signChar = rounded > 0 ? '+' : rounded < 0 ? '−' : '';
      let tone = 'flat';
      if (rounded > 0) tone = invertChange ? 'down' : 'up';
      else if (rounded < 0) tone = invertChange ? 'up' : 'down';
      changeNode = (
        <div className={`scorecard__change scorecard__change--${tone}`}>
          {signChar ? <span className="scorecard__change-sign">{signChar}</span> : null}
          {abs}%
        </div>
      );
    }
  }
  return (
    <div
      className={`scorecard${hasChange ? ' scorecard--with-change' : ''}${className ? ` ${className}` : ''}`}
    >
      <div className="scorecard__title">{title}</div>
      <div className="scorecard__metric">{data}</div>
      {changeNode}
    </div>
  );
};

export const PieGraph = (props) => {
  const {
    className,
    data,
    width,
    height,
    value,
    name,
    fill,
    heading,
    formatter,
    style,
    outerRadius = 80,
    legendLayout = 'vertical',
    legendVerticalAlign = 'middle',
    legendAlign = 'right',
    startAngle = 90,
    endAngle = -270,
    renderTooltip,
    legendMaxItems
  } = props;
  const [fData, setFData] = useState(data);
  useEffect(() => {
    setFData(data);
    if (data.length === 0) {
      setFData([{
       Subtotal: 1e-10,
       name: "No sales"
      }])
    }
  }, [data])
  const legendPayload =
    Number.isFinite(legendMaxItems) && legendMaxItems >= 0
      ? fData.slice(0, legendMaxItems).map((entry, index) => ({
          id: entry?.[name] ?? index,
          value: entry?.[name] ?? '',
          type: 'square',
          color: fill[index % fill.length]
        }))
      : undefined;
  return (
    <div className={`pie-graph${ className ? ` ${className}` : ''}`} style={style || {}}>
      {heading && <div className="line-graph__heading">{heading}</div>}
      <ResponsiveContainer width={width} height={height} >
        <PieChart>
          <Pie
            data={fData}
            dataKey={value}
            nameKey={name}
            cx="50%"
            cy="50%"
            outerRadius={outerRadius}
            startAngle={startAngle}
            endAngle={endAngle}
          >
            {
              fData.map((entry, index) => <Cell key={index} fill={fill[index % fill.length]} />)
            }
          </Pie>
          <Tooltip
            content={typeof renderTooltip === 'function' ? renderTooltip : undefined}
            formatter={
              typeof renderTooltip === 'function'
                ? undefined
                : (value, _name, item) => {
                    const formatted = formatter ? formatter.format(value) : value;
                    const sliceName = item?.payload?.[name] ?? _name;
                    return [formatted, sliceName];
                  }
            }
            labelFormatter={typeof renderTooltip === 'function' ? undefined : () => ''}
          />
          <Legend
            layout={legendLayout}
            verticalAlign={legendVerticalAlign}
            align={legendAlign}
            payload={legendPayload}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export const BarGraph = (props) => {
  const {
    className,
    data,
    width,
    height,
    name,
    fill,
    heading,
    firstKey,
    secondKey,
    style,
    formatters,
    busy = false,
    xAxisInterval
  } = props;
  const [fData, setFData] = useState(data);
  useEffect(() => {
    setFData(data);
    if (data.length === 0) {
      const stub = { [firstKey]: 0 };
      if (secondKey) stub[secondKey] = 0;
      setFData([stub]);
    }
  }, [data, firstKey, secondKey])

  return (
    <div className={`bar-graph${className ? ` ${className}` : ''}`} style={style || {}}>
      {heading && <div className="line-graph__heading">{heading}</div>}
        <ResponsiveContainer width={width} height={height}>
          <BarChart data={fData} style={busy ? { opacity: 0.45 } : undefined}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={name}
              {...(xAxisInterval !== undefined ? { interval: xAxisInterval, tick: { fontSize: 10 } } : {})}
            />
            <YAxis />
            <Tooltip
              formatter={(value, seriesName) => {
                const fmt = formatters?.[seriesName];
                if (fmt && typeof fmt.format === 'function') return [fmt.format(value), seriesName];
                if (typeof fmt === 'function') return [fmt(value), seriesName];
                return [value, seriesName];
              }}
            />
            <Legend />
            <Bar dataKey={firstKey} fill={fill[0]} />
            {secondKey ? <Bar dataKey={secondKey} fill={fill[1] || fill[0]} /> : null}
          </BarChart>
        </ResponsiveContainer>
    </div>
  )
}